import { Link as OriginalLink } from "react-router-dom";
import styled from "styled-components";

const Link = styled(OriginalLink)`
text-decoration: none;
`

export default Link